import { AjaxSource } from '../AjaxSource';

import type { Feature } from 'geojson';
import type { AjaxSourceOptions } from '../Sources.types';

const defaultOptions: AjaxSourceOptions = {
    id: 'shuttle-parking-source',
    url: '/api/vasttrafik/action/parkings',
};

interface ParkingArea {
    parkingLots: ParkingLot[];
}

interface ParkingLot {
    id: string;
    name: string;
    lat: number;
    lon: number;
    totalCapacity: number;
    freeSpaces: number | null;
    parkingType: {
        name: string;
    };
}

export interface ShuttleParkingProperties {
    name: string;
    freeSpaces?: number;
    parkingSpaces?: number;
    provider: string;
    updated?: Date;
}

export class ShuttleParkingsSource extends AjaxSource {
    constructor(options?: Partial<AjaxSourceOptions>) {
        super({ ...defaultOptions, ...options });
    }

    parseData(parkingAreas: ParkingArea[]): Feature[] {
        if (!Array.isArray(parkingAreas)) {
            throw new Error('Shuttleparking response is empty.');
        }
        return parkingAreas.reduce((total, parkingArea) => {
            if (!parkingArea.parkingLots) {
                return total;
            }
            parkingArea.parkingLots.forEach((parkingLot) => {
                const parsedLot = this.parseParking(parkingLot);
                if (parsedLot) {
                    total.push(parsedLot);
                }
            });
            return total;
        }, []);
    }

    parseParking(parking: ParkingLot): Feature {
        return {
            id: parking.id,
            geometry: {
                type: 'Point',
                coordinates: [parking.lon, parking.lat],
            },
            properties: {
                name: parking.name,
                parkingSpaces: parking.totalCapacity,
                freeSpaces: parking.parkingType.name === 'SMARTCARPARK' ? parking.freeSpaces : null,
                updated: parking.parkingType.name === 'SMARTCARPARK' ? new Date() : null,
                provider: 'Västtrafik',
            },
            type: 'Feature',
        };
    }
}
